import { OPENAI_PIXEL_ID } from './marketingPixelConfig.js';

/** @typedef {1 | 2 | 3 | 4} OnboardingStepNumber */

/**
 * @param {OnboardingStepNumber} step
 * @param {'viewed' | 'completed'} phase
 */
export function trackOpenAiOnboardingStep(step, phase) {
  if (typeof window === 'undefined' || !OPENAI_PIXEL_ID) {
    return;
  }

  const oaiq = window.oaiq;
  if (typeof oaiq !== 'function') {
    return;
  }

  if (step < 1 || step > 4) {
    return;
  }

  oaiq('measure', 'custom', {
    type: 'custom',
    custom_event_name: `onboarding_step_${step}_${phase}`,
  });
}

/** @param {string} pathname */
export function onboardingStepForPathname(pathname) {
  const path = pathname.split('?')[0].replace(/\/+$/, '') || '/';
  switch (path) {
    case '/signup':
      return 1;
    case '/verify-email':
      return 2;
    case '/workspace-setup':
      return 3;
    case '/trial-started':
      return 4;
    default:
      return null;
  }
}
